<table>
  <thead>
    <tr>
      <th>
        <mpro-table-column
          [header]="dataFilters.spendingGroup.type"
          subheader="Daily"
          [hideArrows]="true"
        ></mpro-table-column>
      </th>
      <th>
        <mpro-table-column
          header="People"
          subheader="Count"
          [hideArrows]="true"
        ></mpro-table-column>
      </th>
      <th>
        <mpro-table-column
          header="Demand"
          [subheader]="categoryText"
          [hideArrows]="true"
        ></mpro-table-column>
      </th>
      <th>
        <mpro-table-column
          [header]="dataFilters.spendingGroup.type"
          subheader="Share"
          [hideArrows]="true"
        ></mpro-table-column>
      </th>
    </tr>
  </thead>

  <tbody>
    <!-- TODO: Not the best solution for getting the colors -->
    <tr
      *ngFor="let d of sdData?.slice()?.reverse(); let i = index"
      [ngStyle]="{
        backgroundColor:
          d.spending_daily === selected ? getBgColor(d.color) : undefined
      }"
    >
      <td [ngStyle]="{ color: getColor(d.color) }">${{ d.spending_daily }}</td>
      <td>{{ d.people | formatNumber : true }}</td>
      <td>${{ d.spending_ppp | formatNumber : true }}</td>
      <td>{{ d.spending_share | formatNumber : false : ".0-0" }}%</td>
    </tr>
    <tr>
      <td>{{ total.spending_daily }}</td>
      <td>{{ total.people | formatNumber : true }}</td>
      <td>${{ total.spending_ppp | formatNumber : true }}</td>
      <td>{{ total.spending_share | formatNumber : false : ".0-0" }}%</td>
    </tr>
  </tbody>
</table>
